import { getEnv } from './env'

export const isProd = () => getEnv('env') === 'prod'
